import { render } from "./TodoItem.vue?vue&type=template&id=4c937718"
import script from "./TodoItem.vue?vue&type=script&lang=js"
export * from "./TodoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__